<style lang="less">
</style>
<template>
  <div>
    <Drawer
      :closable="false"
      placement="right"
      v-model="drawerVisible"
      width="60%"
      :title="drawerTitle"
    >
      <Row>
        <Col>
          <Card shadow="false">
            <Row>
              <Form
                ref="form"
                :model="form"
                :label-width="90"
                :rules="formValidate"
                style="position: relative"
              >
                <FormItem label="课程标题" prop="courseTitle">
                  <Input v-model="form.courseTitle" style="width: 600px" />
                </FormItem>
                <FormItem label="课程介绍" prop="courseContent">
                  <div ref="editor"></div>
                </FormItem>
                <Form-item label class="br">
                  <Button @click="editHTML" icon="ios-create-outline"
                    >编辑HTML代码</Button
                  >
                  <Button @click="fullscreenModal = true" icon="md-eye"
                    >预览</Button
                  >
                </Form-item>
                <FormItem label="截至报名时间" prop="deadline">
                  <DatePicker
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    @on-change="dataChange"
                    :value="form.deadline"
                    style="width: 300px"
                    placeholder="请输入截至时间"
                  ></DatePicker>
                </FormItem>
                <FormItem label="上课地址" prop="courseAddress">
                  <Input v-model="form.courseAddress" style="width: 600px" />
                </FormItem>
                <FormItem label="报名人数" prop="enrollNum">
                  <Input number v-model="form.enrollNum" style="width: 600px" />
                </FormItem>
                <FormItem label="封面图" prop="courseImage">
                  <upload-input
                    :fileUrl="form.courseImage"
                    fileSize="400"
                    fileWh="750*566"
                    @on-change="handleUpload"
                    width="400px"
                    ref="upload"
                  ></upload-input>
                </FormItem>
                <FormItem label="报名费" prop="coursePrice">
                  <InputNumber
                    style="width: 150px"
                    :min="0"
                    v-model="form.coursePrice"
                    :formatter="
                      (value) => `¥ ${value}`.replace(/B(?=(d{3})+(?!d))/g, ',')
                    "
                    :parser="(value) => value.replace(/¥s?|(,*)/g, '')"
                  ></InputNumber>
                </FormItem>

                <Form-item class="br">
                  <Button
                    type="primary"
                    :loading="submitLoading"
                    @click="handelSubmit"
                    style="width: 100px"
                    >提交</Button
                  >
                  <Button @click="handelCancel">取消</Button>
                </Form-item>
                <Spin size="large" fix v-if="loading"></Spin>
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- html编辑 -->
      <Modal
        title="编辑html代码"
        v-model="showHTMLModal"
        :mask-closable="false"
        :width="900"
        :fullscreen="full"
      >
        <Input
          v-if="!full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
          style="max-height: 60vh; overflow: auto"
        />
        <Input
          v-if="full"
          v-model="dataEdit"
          :autosize="true"
          type="textarea"
        />
        <div slot="footer">
          <Button @click="full = !full" icon="md-expand">全屏开/关</Button>
          <Button
            @click="editHTMLOk"
            type="primary"
            icon="md-checkmark-circle-outline"
            >确定保存</Button
          >
        </div>
      </Modal>
      <Modal title="预览" v-model="fullscreenModal" fullscreen>
        <div v-html="form.courseContent">{{ form.courseContent }}</div>
        <div slot="footer">
          <Button @click="fullscreenModal = false">关闭</Button>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
<script>
import { uploadFile } from "@/api/index";
import { addOffCourse, editOffCourse, getOffCourse } from "@/api/bus";
import userChoose from "../../my-components/flyme/user-choose";
import uploadInput from "@/views/my-components/flyme/upload-input";
import E from "wangeditor";
// 表情包配置 自定义表情可在该js文件中统一修改
import { sina } from "@/libs/emoji";

let editor = null;
var xss = require("xss");
export default {
  name: "offcourse-drawer",
  components: {
    userChoose,
    uploadInput,
  },
  data() {
    return {
      type: 0,
      userType: "UT_LECTURER",
      loading: false, // 表单加载状态
      selectUsers: [],
      drawerTitle: "添加课程",
      drawerVisible: false,
      form: {
        courseTitle: "",
        courseContent: "",
        lecturerId: "",
        deadline: "",
        enrollNum: 0,
        courseStatus: 1,
        courseImage: "",
        courseAddrese: "",
        coursePrice: 0,
      },
      formValidate: {
        courseTitle: [
          { required: true, message: "课程名称不能为空", trigger: "blur" },
        ],
        coursePrice: [
          {
            required: true,
            type: "number",
            message: "报名费不能为空",
            trigger: "blur",
          },
        ],
        enrollNum: [
          {
            required: true,
            type: "number",
            message: "报名人数不能为空",
            trigger: "blur",
          },
        ],
        courseContent: [
          { required: true, message: "课程介绍不能为空", trigger: "blur" },
        ],
      },
      submitLoading: false, // 添加或编辑提交状态
      dataEdit: "", // 编辑数据
      showHTMLModal: false, // 显示html
      full: false, // html全屏开关
      fullscreenModal: false, // 显示全屏预览
    };
  },
  methods: {
    init() {
      this.initEditor();
    },
    showDrawer(params) {
      if (params.id) {
        this.type = 1;
        this.drawerTitle = "编辑课程";
        this.form.id = params.id;
        this.getData();
      } else {
        this.$refs.form.resetFields();
        editor.txt.html("");
        this.$refs.upload.setPicUrl("");
        this.drawerTitle = "添加课程";
        this.type = 0;
      }
      this.drawerVisible = true;
    },
    //打开用户选择
    showUserChooseDrawer() {
      this.$refs.user.showDrawer();
    },
    clearUser() {
      this.$refs.user.clearSelectUser();
    },
    initEditor() {
      let that = this;
      editor = new E(this.$refs.editor);
      let editorConfig = editor.customConfig
        ? editor.customConfig
        : editor.config;
      editorConfig.onchange = (html) => {
        this.form.courseContent = html;
      };
      editorConfig.uploadImgServer = uploadFile;
      editorConfig.uploadImgHeaders = {
        Authorization: that.getStore("accessToken"),
      };
      editorConfig.uploadFileName = "file";
      editorConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {},
        success: function (xhr, editor, result) {},
        fail: function (xhr, editor, result) {
          that.$Message.error("上传图片失败");
        },
        error: function (xhr, editor) {
          that.$Message.error("上传图片出错");
        },
        timeout: function (xhr, editor) {
          that.$Message.error("上传图片超时");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.status === true) {
            let url = result.data.fileUrl;
            insertImg(url);
            that.$Message.success("上传图片成功");
          } else {
            that.$Message.error(result.info);
          }
        },
      };
      editorConfig.fontNames = ["微软雅黑", "宋体", "黑体", "Arial"];
      editorConfig.emotions = [
        {
          title: "新浪",
          type: "image",
          content: sina,
        },
      ];
      editor.create();
    },
    editHTML() {
      this.dataEdit = this.form.courseContent;
      this.showHTMLModal = true;
    },
    editHTMLOk() {
      editor.txt.html(this.dataEdit);
      this.form.courseContent = xss(this.dataEdit);
      this.showHTMLModal = false;
    },
    getData() {
      this.loading = true;
      getOffCourse(this.form.id).then((res) => {
        this.loading = false;
        if (res.status === true) {
          editor.txt.html(res.data.courseContent);
          this.form = res.data;
          this.$refs.upload.setPicUrl(this.form.courseImage);
        }
      });
    },
    dataChange(data1, data2) {
      this.form.deadline = data1;
    },
    handelSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // 用户id数据
            let ids = [];
            this.selectUsers.forEach((e) => {
              ids.push(e.id);
            });
            this.form.lecturerId = ids;
            addOffCourse(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          } else if (this.type === 1) {
            // 编辑
            editOffCourse(this.form).then((res) => {
              this.submitLoading = false;
              if (res.status === true) {
                this.$Message.success("操作成功");
                this.$parent.getDataList();
                this.drawerVisible = false;
              }
            });
          }
        }
      });
    },
    handleSelectUser(v) {
      this.form.lecturerId = v[0].id;
      this.selectUsers = v;
    },
    handelCancel() {
      this.drawerVisible = false;
    },
    handleUpload(v) {
      this.form.courseImage = v.fileUrl;
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>